import { render, staticRenderFns } from "./UserNeighbors.vue?vue&type=template&id=7498d2e7&"
import script from "./UserNeighbors.vue?vue&type=script&lang=js&"
export * from "./UserNeighbors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports